<template>
    <div class="wrapper">
        <CCHeader></CCHeader>
        <div class="data-wrapper">
            <CCSideBar></CCSideBar>
            <div class="main" v-bind:class="{'loaded-data': reportData.length >= 25}">
                <div class="report" v-bind:class="{'sidebar-active': getSideBarStatus()}">
                    <CCRawDataPartnersReportFilters :namespace="namespace"></CCRawDataPartnersReportFilters>
                    <CCRawDataPartnersReportTable :data="reportData"
                                                  :columns="columns"
                                                  :defaultColumns="defaultColumns"
                                                  :namespace="namespace">
                    </CCRawDataPartnersReportTable>
                </div>
            </div>
        </div>
        <Loading :active="loadingStatus" :can-cancel="false" :on-cancel="whenCancelled"></Loading>
    </div>
</template>

<script>

    import '@/style/reports/base_report_style.scss';

    import rawDataPartnersReport from '@/store/modules/rawDataPartnersReport/index';
    import baseReportFiltersModule from '@/store/modules/baseReport/filter/index';
    import baseReportDataModule from '@/store/modules/baseReport/table/index';

    import CCHeader from '@/components/common/CCHeader';
    import CCSideBar from '@/components/common/CCSideBar';
    import CCRawDataPartnersReportTable from '@/components/reports/rawDataPartnersReport/CCRawDataPartnersReportTable';
    import CCRawDataPartnersReportFilters from '@/components/reports/rawDataPartnersReport/CCRawDataPartnersReportFilters';

    import baseReportMixin from '@/components/mixins/baseReportMixin';
    import URLSyncMixin from '@/components/mixins/URLSyncMixin.js';

    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.min.css';

    import {reportColumnsDefinitions} from '../configs/raw-data-partners-report-config';

    export default {
        name: "RawDataPartnersReport",
        components: {
            CCHeader,
            CCSideBar,
            CCRawDataPartnersReportTable,
            CCRawDataPartnersReportFilters,
            Loading
        },
        mixins: [
            baseReportMixin,
            URLSyncMixin
        ],
        data() {
            return {
                namespace: 'rawDataPartnersReport',
                defaultColumns: reportColumnsDefinitions,
                columns: [],
                isFiltersLoadingStart: false
            }
        },
        beforeCreate(){
            if (!('rawDataPartnersReport/' in this.$store._modulesNamespaceMap))
            {
                this.$store.registerModule('rawDataPartnersReport', {
                    namespaced: true,
                    modules: {
                        baseReportDataModule,
                        baseReportFiltersModule,
                        rawDataPartnersReport
                    }
                });
            }
        },
        created(){
            for (let i = 0; i < reportColumnsDefinitions.length; i++) {
                reportColumnsDefinitions[i]['position'] = i;
            }

            let query = this.$route.query;
            if (query !== undefined) {
                let encodedColumns = query.columns;
                if (encodedColumns !== undefined) {
                    let decodedColumns = atob(encodedColumns);
                    if (decodedColumns !== undefined && decodedColumns !== null) {
                        let userColumns = JSON.parse(decodedColumns);

                        reportColumnsDefinitions.forEach(columnDefinition => {
                            columnDefinition.checked = false;
                            userColumns.forEach(userColumn => {
                                if(columnDefinition.field === userColumn.field) {
                                    columnDefinition.checked = true;
                                }
                            })
                        })

                    }
                }
            }
        },
        watch: {
            reportData: function(value)
            {
                if (!this.loadingStatus && value.length === 0)
                {
                    this.showNofiticationEmptyData();
                }
            }
        },
        computed: {
            reportData: function () {
                return this.getReportDataGetter();
            },
            loadingStatus: function () {
                return this.getLoadingStatus();
            }
        },
        methods: {
            getCustomReportFilters: function () {
                return this.$store.getters[this.namespace + '/getCustomReportFilters'];
            },
            whenCancelled: function () {

            }
        }
    }


</script>

<style scoped lang="scss">
    .table-wrapper {
        max-width: 100% !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/RawDataPartnersReport.vue